package one.healthium.domain.user.models

import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.format.char
import kotlinx.datetime.toLocalDateTime
import one.healthium.base.utils.Formatters.formatWeight
import one.healthium.base.utils.localizedMonthNames
import one.healthium.base.utils.toHeightString
import one.healthium.loco.resolveAsync
import kotlin.time.Clock
import kotlin.time.Duration.Companion.days


suspend fun UserProfileModel.bindPlaceholderValues(template: String, isMetric: Boolean): String {
    val weight = weight?.formatWeight(isMetric)?.resolveAsync()
    val targetWeight = targetWeight?.formatWeight(isMetric)?.resolveAsync()
    val yourTeens = yourTeens.resolveAsync()
    val gender = gender?.displayValue()?.resolveAsync()
    val prognoseLose21 = prognoseLose?.formatWeight(isMetric)?.resolveAsync()
    val minRecommendedWeight = minRecommendedWeight?.formatWeight(isMetric)?.resolveAsync()
    val maxRecommenderWeight = maxRecommendedWeight?.formatWeight(isMetric)?.resolveAsync()
    val weightToLose = weightToLose?.formatWeight(isMetric)?.resolveAsync()
    val prognoseWeight21 = prognoseWeightLoss(PersonalPlanPeriod.In21days)?.formatWeight(isMetric)?.resolveAsync()
    val prognoseWeight3month = prognoseWeightLoss(PersonalPlanPeriod.In3month)?.formatWeight(isMetric)?.resolveAsync()
    val prognoseWeight3monthShort = prognoseWeightLoss(PersonalPlanPeriod.In3monthShort)?.formatWeight(isMetric)?.resolveAsync()

    return template
        .replace("""\{[^}]+\}""".toRegex()) { matchResult ->
            val splitedPlaceholder = matchResult.value.trim('{', '}').split("||")

            val placeholderValue = splitedPlaceholder.firstOrNull()
            val defaultValue = splitedPlaceholder.lastOrNull()

            val replaceValue = when (placeholderValue?.lowercase()) {
                "name" -> name?.trim()
                "age" -> age?.toString()
                "weight" -> weight
                "target_weight" -> targetWeight
                "height" -> height?.toHeightString(isMetric)
                "bmi" -> bmi?.toString()
                "target_bmi" -> targetBmi?.toString()
                "down_years" -> age?.let { it / 10 * 10 }?.toString()
                "your_teens" -> yourTeens
                "gender" -> gender
                "lose_percent" -> losePercent?.let { "$it%" }
                "prognose_lose_21" -> prognoseLose21
                "min_recommended_weight" -> minRecommendedWeight
                "max_recommended_weight" -> maxRecommenderWeight
                "weight_to_lose" -> weightToLose
                "prognose_weight_21" -> prognoseWeight21
                "prognose_weight_3month" -> prognoseWeight3month
                "prognose_weight_3month_short" -> prognoseWeight3monthShort
                "in_21days" -> inPrognoseDays(prognoseDays(PersonalPlanPeriod.In21days))
                "in_3months" -> inPrognoseDays(prognoseDays(PersonalPlanPeriod.In3month))
                "in_3months_short" -> inPrognoseDays(prognoseDays(PersonalPlanPeriod.In3monthShort))
                else -> additionalInfo[placeholderValue]?.firstOrNull()?.altText
            }
            replaceValue.let { if (it.isNullOrEmpty()) defaultValue else it }.orEmpty()
        }
}

private fun inPrognoseDays(days: Int): String {
    val days21 = Clock.System.now().plus(days.days)
    val dateFormat = LocalDate.Format {
        monthName(localizedMonthNames())
        char(' ')
        day()
    }

    return dateFormat.format(days21.toLocalDateTime(TimeZone.currentSystemDefault()).date)
}
